export default __webpack_public_path__ + "static/media/disk.255c8b7a.svg";